import * as React from "react";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DispatchProps {}

interface OwnState {
  submitDisabled: boolean;
}

type Props = DispatchProps;

class SentConfirmation extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public continueButton: any;

  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  public render() {
    return (
      <>
        <div className="question">
          <div className="mt-5">We have contacted your care team.</div>
        </div>
        <div className="body white">
          <div className="pl-5 pr-5 info">
            <div>
              Your answers and information has been sent to a triage center. We will contact you at
              the phone number provided and attempt to speak with you via phone, SMS messaging, or
              video conferencing.
            </div>
            <div className="mt-20">
              We are working as fast as possible to respond to all of those in need.
            </div>

            <button className="mt-40 mb-30 full-width highlight">
              Schedule Virtual Appointment
            </button>

            <div className="mt-20">
              For more information:
              <button className="btn-link small">COVID-19 CDC Frequently Asked Question</button>
              <button className="btn-link small">Self Isolation</button>
              <button className="btn-link small">Social Distancing</button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SentConfirmation;
